// Angular
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Misc
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { LandingComponent } from './components/landing/landing.component';
import { BlankComponent } from './components/blank/blank.component';

// Admin
import { LoginAdminComponent } from './components/admin/login/login.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { UsersComponent } from './components/admin/users/users.component';
import { AdminsComponent } from './components/admin/admins/admins.component';
import { RentwiseUsersComponent } from './components/admin/rentwise-users/rentwise-users.component';
import { FheUsersComponent } from './components/admin/fhe-users/fhe-users.component';
import { InviteComponent } from './components/admin/invite/invite.component';
import { AdminHpPropertiesComponent } from './components/admin/admin-hp-properties/admin-hp-properties.component';
import { AdminHpPropertyDialogComponent } from './components/admin/admin-hp-properties/admin-hp-property-dialog/admin-hp-property-dialog.component';
import { AdminClientPropertiesComponent } from './components/admin/admin-client-properties/admin-client-properties.component';
import { AdminClientPropertyDialogComponent } from './components/admin/admin-client-properties/admin-client-property-dialog/admin-client-property-dialog.component';
import { AdminClientPropertyFilesComponent } from './components/admin/admin-client-properties/admin-client-property-files/admin-client-property-files.component';
import { AdminPropertiesChallengesComponent } from './components/admin/admin-properties-challenges/admin-properties-challenges.component';
import { NewAgencyComponent } from './components/admin/new-agency/new-agency.component';
import { NewRegisterComponent } from './components/admin/new-register/new-register.component';
import { EditAgencyComponent } from './components/admin/edit-agency/edit-agency.component';
import { ForgotPasswordAdminComponent } from './components/admin/forgot-password-admin/forgot-password-admin.component';
import { ResetPasswordAdminComponent } from './components/admin/reset-password-admin/reset-password-admin.component';
import { AdminEvaluationsComponent } from './components/admin/admin-evaluations/admin-evaluations.component';
import { RentwiseEvaluationsComponent } from './components/admin/rentwise-evaluations/rentwise-evaluations.component';
import { CommentsListComponent } from './components/admin/shared/comments-list/comments-list.component';
import { AdminBannedListComponent } from './components/admin/admin-banned-list/admin-banned-list.component';
import { AdminQuizQuestionsComponent } from './components/admin/admin-quiz-questions/admin-quiz-questions.component';
import { AdminQuizQuestionDialogComponent } from './components/admin/admin-quiz-questions/admin-quiz-question-dialog/admin-quiz-question-dialog.component';
import { RentwiseCertificateComponent } from './components/admin/rentwise-certificate/rentwise-certificate.component';
import { UploadUsersDialogComponent } from './components/admin/shared/dialogs/upload-users-dialog/upload-users-dialog.component';
import { InviteUsersDialogComponent } from './components/admin/shared/dialogs/invite-users-dialog/invite-users-dialog.component';
import { AdminCoursesComponent } from './components/admin/admin-courses/admin-courses.component';
import { EditCoursePageComponent } from './components/admin/admin-courses/edit-course-page/edit-course-page.component';
import { EditCourseModuleDialogComponent } from './components/admin/admin-courses/edit-course-module-dialog/edit-course-module-dialog.component';
import { AdminAccountInfoComponent } from './components/admin/admin-account-info/admin-account-info.component';
import { AdminInfoDialogComponent } from './components/admin/admins/admin-info-dialog/admin-info-dialog.component';

// User
import { SignUpComponent } from './components/sign-up/sign-up.component'
import { SignUp2Component } from './components/sign-up2/sign-up2.component';
import { SignUp3Component } from './components/sign-up3/sign-up3.component';
import { SignUp4Component } from './components/sign-up4/sign-up4.component';
import { LoginComponent } from './components/login/login.component';
import { AccountInfoComponent } from './components/account-info/account-info.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PropertiesRecordsComponent } from './components/public-records/properties-records/properties-records.component';

// Core
import { CoreModule } from './core/core.module';
import { ErrorsModule } from './core/errors/errors.module';
import { GuardsModule } from './guards/guards.module';

// Libraries
import { SharedModule } from './shared/shared.module';
import { JwtModule } from "@auth0/angular-jwt";
import { MDBBootstrapModule } from 'angular-bootstrap-md'
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FlashMessagesModule } from 'flash-messages-angular';
import { NgxPayPalModule } from 'ngx-paypal';

// Course
import { EnrollComponent } from './components/enroll/enroll.component';
import { CoursesOverviewComponent } from './components/courses/courses-overview/courses-overview.component';
import { QuizSystemModule } from './components/courses/quiz-system/quiz-system.module';
import { FairHousingEducationModule } from './components/courses/fair-housing-education/fair-housing-education.module';
import { RentwiseModule } from './components/courses/rentwise/rentwise.module';

// Fair Housing Education
import { FairHousingEducationComponent } from './components/courses/fair-housing-education/fair-housing-education.component';
import { Module1FheComponent } from './components/courses/fair-housing-education/module1-fhe/module1-fhe.component';
import { Module2FheComponent } from './components/courses/fair-housing-education/module2-fhe/module2-fhe.component';
import { Module3FheComponent } from './components/courses/fair-housing-education/module3-fhe/module3-fhe.component';
import { Module4FheComponent } from './components/courses/fair-housing-education/module4-fhe/module4-fhe.component';
import { Module5FheComponent } from './components/courses/fair-housing-education/module5-fhe/module5-fhe.component';
import { Module6FheComponent } from './components/courses/fair-housing-education/module6-fhe/module6-fhe.component';
import { Module7FheComponent } from './components/courses/fair-housing-education/module7-fhe/module7-fhe.component';
import { Module8FheComponent } from './components/courses/fair-housing-education/module8-fhe/module8-fhe.component';
import { Module9FheComponent } from './components/courses/fair-housing-education/module9-fhe/module9-fhe.component';
import { Module10FheComponent } from './components/courses/fair-housing-education/module10-fhe/module10-fhe.component';
import { CertificateFheComponent } from './components/courses/fair-housing-education/certificate-fhe/certificate-fhe.component';
import { PropertiesFheComponent } from './components/courses/fair-housing-education/properties-fhe/properties-fhe.component';
import { PropertyFheDialogComponent } from './components/courses/fair-housing-education/properties-fhe/property-fhe-dialog/property-fhe-dialog.component';

// RentWise
import { RentwiseComponent } from './components/courses/rentwise/rentwise.component';
import { PreEvaluationRwComponent } from './components/courses/rentwise/pre-evaluation-rw/pre-evaluation-rw.component';
import { Module1RwComponent } from './components/courses/rentwise/module1-rw/module1-rw.component';
import { Module2RwComponent } from './components/courses/rentwise/module2-rw/module2-rw.component';
import { Module3RwComponent } from './components/courses/rentwise/module3-rw/module3-rw.component';
import { Module4RwComponent } from './components/courses/rentwise/module4-rw/module4-rw.component';
import { Module5RwComponent } from './components/courses/rentwise/module5-rw/module5-rw.component';
import { Module6RwComponent } from './components/courses/rentwise/module6-rw/module6-rw.component';
import { PostEvaluationRwComponent } from './components/courses/rentwise/post-evaluation-rw/post-evaluation-rw.component';
import { CertificateRwComponent } from './components/courses/rentwise/certificate-rw/certificate-rw.component';
import { ClientPropertiesRwComponent } from './components/courses/rentwise/client-properties-rw/client-properties-rw.component';
import { ClientPropertyDialogComponent } from './components/courses/rentwise/client-properties-rw/client-property-dialog/client-property-dialog.component';
import { ClientPropertyFilesComponent } from './components/courses/rentwise/client-properties-rw/client-property-files/client-property-files.component';
import { ConditionChecklistRwComponent } from './components/courses/rentwise/condition-checklist-rw/condition-checklist-rw.component';

// Created services
import { CoursesService } from './services/courses.service';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';

// Public Reporting
import { PublicRecordsComponent } from './components/public-records/public-records.component';
import { RentwiseRecordsComponent } from './components/public-records/rentwise-records/rentwise-records.component';
import { FheRecordsComponent } from './components/public-records/fhe-records/fhe-records.component';

@NgModule({
  declarations: [

    // Angular
    AppComponent,

    // Misc
    NavBarComponent,
    LandingComponent,
    BlankComponent,

    // Admin
    LoginAdminComponent,
    AdminHomeComponent,
    UsersComponent,
    AdminsComponent,
    RentwiseUsersComponent,
    AdminEvaluationsComponent,
    RentwiseEvaluationsComponent,
    FheUsersComponent,
    NewAgencyComponent,
    InviteComponent,
    AdminHpPropertiesComponent,
    AdminHpPropertyDialogComponent,
    AdminClientPropertiesComponent,
    AdminClientPropertyDialogComponent,
    AdminClientPropertyFilesComponent,
    AdminPropertiesChallengesComponent,
    NewRegisterComponent,
    EditAgencyComponent,
    ForgotPasswordAdminComponent,
    ResetPasswordAdminComponent,
    UploadUsersDialogComponent,
    CommentsListComponent,
    AdminBannedListComponent,
    AdminQuizQuestionsComponent,
    AdminQuizQuestionDialogComponent,
    RentwiseCertificateComponent,
    InviteUsersDialogComponent,
    AdminCoursesComponent,
    EditCoursePageComponent,
    EditCourseModuleDialogComponent,
    AdminAccountInfoComponent,
    AdminInfoDialogComponent,

    // User
    SignUpComponent,
    SignUp2Component,
    SignUp3Component,
    SignUp4Component,
    LoginComponent,
    AccountInfoComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,

    // Courses
    CoursesOverviewComponent,
    EnrollComponent,

    // Fair Housing Education
    FairHousingEducationComponent,
    Module1FheComponent,
    Module2FheComponent,
    Module3FheComponent,
    Module4FheComponent,
    Module5FheComponent,
    Module6FheComponent,
    Module7FheComponent,
    Module8FheComponent,
    Module9FheComponent,
    Module10FheComponent,
    CertificateFheComponent,
    PropertiesFheComponent,
    PropertyFheDialogComponent,

    // RentWise
    RentwiseComponent,
    PreEvaluationRwComponent,
    Module1RwComponent,
    Module2RwComponent,
    Module3RwComponent,
    Module4RwComponent,
    Module5RwComponent,
    Module6RwComponent,
    PostEvaluationRwComponent,
    CertificateRwComponent,
    ClientPropertiesRwComponent,
    ClientPropertyDialogComponent,
    ClientPropertyFilesComponent,
    ConditionChecklistRwComponent,

    // Public Reporting
    PublicRecordsComponent,
    RentwiseRecordsComponent,
    FheRecordsComponent,
    PropertiesRecordsComponent,
  ],
  imports: [
    AppRoutingModule,
    HttpClientModule,
    CoreModule.forRoot(),
    ErrorsModule.forRoot(),
    GuardsModule.forRoot(),
    MDBBootstrapModule.forRoot(),
    NgCircleProgressModule.forRoot(),
    FlashMessagesModule.forRoot(),
    NgxPayPalModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem("access_token");
        },
      },
    }),
    SharedModule,
    QuizSystemModule,
    FairHousingEducationModule,
    RentwiseModule,
  ],
  providers: [
    CoursesService,
    AuthService,
    UserService,
  ],
  bootstrap: [AppComponent]
})


export class AppModule { }
